import axios from "../../axios.js";
const getRooms = async ({ commit }, data) => {
  const search_param = data.search_param
    ? `filter_param=${data.search_param}&`
    : "";
  const page_number =
    data.page_number !== null ? `page_number=${data.page_number}&` : "";
  const on_page = data.on_page !== null ? `on_page=${data.on_page}&` : "";
  const group = data.group !== null ? `group=${data.group}&` : "";
  const date_from = data.date_from
    ? `date_from=${data.date_from.toISOString().split("T")[0]}&`
    : "";
  const date_to = data.date_to
    ? `date_to=${data.date_to.toISOString().split("T")[0]}&`
    : "";
  let only_unread;
  let only_read;

  if (
    (!data.filter_param && !data.search_param) ||
    data.filter_param === "ALL" ||
    data.search_param === "ALL"
  ) {
    (only_unread = `only_unread=false&`), (only_read = `only_read=false&`);
  }
  if (data.filter_param === "READ" || data.search_param === "READ") {
    only_read = `only_read=true&`;
    only_unread = `only_unread=false&`;
  }
  if (data.filter_param === "UNREAD" || data.search_param === "UNREAD") {
    only_read = `only_read=false&`;
    only_unread = `only_unread=true&`;
  }
  let url;
  if (data.on_page) {
    url = `api/chat/all?${page_number}${on_page}${search_param}${only_unread}${only_read}${group}${date_from}${date_to}`;
  } else {
    url = `api/chat/all?${search_param}${date_from}${date_to}`;
  }

  await axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      commit("UPDATE_ROOMS", response.data);
    })
    .catch((err) => {
      console.log(err.response);
    });
};
const getMessages = async ({ commit }, data) => {
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const url = `/api/chat/messages/${data.user_id}?${on_page}${page_number}`;
  await axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(async (response) => {
      await commit("UPDATE_MESSAGES", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const addNewMessageToMessages = async ({ commit }, message) => {
  await commit("ADD_NEW_MESSAGE_TO_MESSAGES", message);
};
const sendMessage = ({ commit, dispatch }, data) => {
  const { user_id, message, file } = data;
  const url = `api/chat/send`;

  const body = new FormData();
  file && body.append("file", file);

  body.append("user_id", user_id);
  body.append("message", message);

  const config = {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };
  axios
    .post(url, body, config)
    .then(async () => {
      await commit("SEND_MESSAGE_SUCCESS");
      dispatch("getMessages", { user_id: data.user_id, token: data.token });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default {
  sendMessage,
  getMessages,
  getRooms,
  addNewMessageToMessages,
};
